<template>
  <p class="text-lg" :class="[props.isActive ? 'text-red-50' : 'text-gray-60', !props.isActive && 'line-clamp-1']">{{ title }}</p>
</template>

<script setup lang="ts">
interface Props {
  title: string
  isActive?: boolean
}

const props = withDefaults(defineProps<Props>(), { isActive: true })
</script>
